import type {
	BranchAvailabilityFamily,
	BranchAvailabilitySource,
	BranchPageAvailability,
} from './types/branchAvailability';

export const GLOBUS_SEO_TITLE = 'Globus - TADY SE SVĚT TOČÍ KOLEM VÁS!';
export const GLOBAL_BRANCH_SLUG = 'globus';
export const DEFAULT_HYPERMARKET = 'praha-cakovice';
export const TIMEZONE = 'Europe/Prague';
export const GB_LEVEL_PRICES = [0, 8000, 16000];
export const ROOT_PRODUCT_CATEGORY_ID = 'cls_czr_click_and_collect';
export const HYPERMARKET_CHANGE_FLAG_COOKIE = 'hypermarketChangedFlag';
export const SMART_BANNER_COOKIE = 'smart-banner';
export const STATIC_ASSET_MAX_AGE = 60 * 60 * 24 * 30;
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
export const PAGES_MAX_AGE = 60;
export const REQUEST_TIMEOUT_IN_SECONDS = 10;
export const THIS_AND_THAT_TIMEOUT_IN_SECONDS = 5;
export const GTM_ID = 'GTM-NCTHX82';
export const GOOGLE_AD_HOMEPAGE = 'div-gpt-ad-1690355574033-0';
export const GOOGLE_AD_HOMEPAGE_2 = 'div-gpt-ad-1701268253563-0';
export const GOOGLE_AD_BLOG = 'div-gpt-ad-1690355746351-0';
export const GOOGLE_AD_BLOG_2 = 'div-gpt-ad-1701275098142-0';
export const GOOGLE_AD_GLOBUSBONUS = 'div-gpt-ad-1701348383841-0';
export const GOOGLE_AD_RECIPES = 'div-gpt-ad-1690355907602-0';
export const GOOGLE_AD_RECIPES_2 = 'div-gpt-ad-1701350346502-0';
export const GOOGLE_AD_ABOUT = 'div-gpt-ad-1690356093046-0';
export const GOOGLE_AD_SERVICES = 'div-gpt-ad-1690356252471-0';
export const GOOGLE_AD_ACTIONOFFER: Record<string, string> = {
	'/22962186754/Akciacelanabidka': 'div-gpt-ad-1690356387619-0',
	'/22962186754/Akciacelanabidka/second_small_banner': 'div-gpt-ad-1701274409688-0',
	'/22962186754/Akciacelanabidka/3rd_small_banner': 'div-gpt-ad-1704898742322-0',
	'/22962186754/Akciacelanabidka/4th_small_banner': 'div-gpt-ad-1704898702290-0',
	'/22962186754/Akciacelanabidka/5th_small_banner': 'div-gpt-ad-1704898673640-0',
	'/22962186754/Akciacelanabidka/6th_small_banner': 'div-gpt-ad-1704898640995-0',
	'/22962186754/Akciacelanabidka/7th_small_banner': 'div-gpt-ad-1704898605361-0',
	'/22962186754/Akciacelanabidka/8th_small_banner': 'div-gpt-ad-1704898567951-0',
	'/22962186754/Akciacelanabidka/9th_small_banner': 'div-gpt-ad-1704898454570-0',
	'/22962186754/Akciacelanabidka/10th_small_banner': 'div-gpt-ad-1704897931897-0',
};
export const GOOGLE_AD_ACTIONOFFER_BOTTOM = 'div-gpt-ad-1701341755984-0';
export const PRICE_LEVELS_RANGE = [
	{range: [GB_LEVEL_PRICES[0], GB_LEVEL_PRICES[1]], level: 2},
	{range: [GB_LEVEL_PRICES[1], GB_LEVEL_PRICES[2]], level: 3},
	{range: [GB_LEVEL_PRICES[2], Infinity], level: 3, isGold: true},
];
export const MY_GLOBUS_PRESENTATION_SLIDESHOW_VERSION = '0.0.1';
export const TOAST_NOTIFICATION_DURATION = 7000;
export const KONTOBARIERY_CUSTOMER_CLUB = 8;
export const KONTOBARIERY = {id: '-3', label: 'Partnerské produkty', slug: 'partnerske-produkty'};
export const MYGLOBUSPRICES = {id: '-2', label: 'Můj Globus ceny', slug: 'muj-globus-ceny'};
export const THISANDTHAT = {id: '-1', label: 'Pro Vás', slug: 'pro-vas'};
export const LEAFLET_MAX_DAYS_IN_FUTURE = 3;
export const GASTRO_FRONTEND_ID = 666;
export const RESTAURANT_MEAL_PRESENTATION_FRONTEND_ID = 104;
export const DEFAULT_BRANCH_PAGE_AVAILABILITY: BranchPageAvailability = {
	hasLeaflets: false,
	hasOnlineOrder: false,
	hasServices: false,
	hasRestaurant: false,
};
export const BRANCH_AVAILABILITY_FAMILY_ROOTS: Record<BranchAvailabilityFamily, string> = {
	hypermarket: '_globus-cz/_pobocky',
	fresh: '_globus-cz/_fresh-pobocky',
};
export const BRANCH_AVAILABILITY_SOURCES: BranchAvailabilitySource[] = [
	{
		key: 'hasLeaflets',
		contentType: 'PageTypeLeafletListing',
	},
	{
		key: 'hasOnlineOrder',
		contentType: 'PageTypeOnlineOrderHomepage',
	},
	{
		key: 'hasServices',
		contentType: 'PageTypeServicesHomepage',
	},
	{
		key: 'hasRestaurant',
		contentType: 'PageTypeRestaurant',
	},
];
export const OFFER_PRODUCTS_PER_PAGE = 24;
export const PREFERRED_MENU_MEALTYPE_ID = 12;
export const FOLLOW_UP_TILES_SLUG = '_globus-cz/komponenty/kam-dal';

// GSOA_ID - houseNumber
export const GLOBUS_ONLINE_GSOA_ID = 4705; // houseNumber of Globus Online
export const GLOBUS_HOME_GSOA_ID = 4005; // houseNumber of Globus Home (PRAHA - ČAKOVICE)
export const GLOBUS_ONLINE_GSOA_IDS = ['4003', '4005', '4007']; // houseNumbers of Globus Online - [Zlicin || Praha - Čakovice || Ostrava]

// Header scroll constants
export const HEADER_STICKY_SCROLL_RATIO = 0.8; // Ratio of header height at which sticky mode activates (top > headerHeight * ratio)
export const HEADER_STICKY_HEIGHT = 64; // Height of minified header in px
export const STICKY_NAV_HEIGHT = 48; // Height of sticky anchor navigation in px
export const HEADER_DEFAULT_HEIGHT = 112; // Default header height as fallback

export const RIBBON_VHELP_CLUB_ID = '8';

export const LEAFLET_ZOOM_EXCLUDE_CLASS = 'leaflet-zoom-exclude';
export const LEAFLET_ZOOM_SUPPRESS_CLICKS_CLASS = 'leaflet-zoom-suppress-clicks';
